'use strict';

import jQuery from 'jquery';
import cookie from './../../vendor/jquery.cookie';

var Autoplay = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * 
     * @param urls
     */
    publicNS.setAutoplayCookie = function setAutoplayCookie(urls) {

      // Stringify the array for storage
      var jsonStr = encodeURI(JSON.stringify(urls));

      // Destroy the previous cookie
      publicNS.deleteAutoplayCookie();

      // Set the cookie
      // Cookies should be set to our current domain only
      $.cookie("autoplay", jsonStr, {
        expires: 1,
        path: '/',
        hostOnly: true
      });
    };

    /**
     * 
     * @param url
     */
    publicNS.addAutoplayURL = function addAutoPlayURL(url) {
      // Get the data from the cookie, if it exists
      // Otherwise, set the value as the first item in the array
      // If there are other values append it to the list and save it back

      var cookie = publicNS.getAutoplayCookie(),
          urls = [];

      if (cookie === null || cookie === undefined) {

        // Push the url into the array
        urls.push(url);
      } else {

        // Get the array of urls from the cookie if it exists
        urls = cookie;

        // Make sure that we only put the url into the array once
        if ( $.inArray(url, urls) === -1 ) {
          urls.push(url);
        }

        // Set the autoplay cookie with the new urls
        publicNS.setAutoplayCookie(urls);
      }
    };

    /**
     * 
     * @returns {Array}
     */
    publicNS.getAutoplayCookie = function getAutoplayCookie() {
      try {
        // Return the decoded array
        return JSON.parse(decodeURI($.cookie('autoplay')));
      } catch (e) {
        // Return an empty array
        return [];
      }
    };

    /**
     * 
     */
    publicNS.deleteAutoplayCookie = function deleteAutoplayCookie() {
      // Remove the cookie
      $.removeCookie('autoplay');
    };

    /**
     * Construct a new instance
     */
    privateNS.init = function init() {

      // Create a reference to the window
      privateNS.$document = $(document);

      // Return the public namespace
      return publicNS;
    };

    return privateNS.init();
  };
})(jQuery);

export default new Autoplay();
